import React, { useEffect } from 'react'
import MultiPageSearchContainer from 'redux/containers/pages/search/MultiPageSearchContainer'

const Infinite = (props) => {
  const {
    searchPhrase,
    searchType,
    pageLimit,
    pageNumber,
    query,
    setSearchState,
    setSearchResponse,
    setCurrentSearchPhrase,
    setSearchPaginationMode
  } = props

  useEffect(() => {
    setSearchState && setSearchState({ pageLimit, pageNumber, paginationMode: 'all', query, searchPhrase, searchType })
  }, [pageLimit, pageNumber, query, searchPhrase, searchType, setSearchState])

  useEffect(() => {
    return () => {
      setSearchResponse(null)
      setCurrentSearchPhrase('')
      setSearchPaginationMode('paged')
    }
  }, [])

  return (
    <MultiPageSearchContainer key={JSON.stringify(props)} />
  )
}

export default Infinite
